import { Route, Routes } from "react-router-dom";
import Home from "./Modules/Home/index";
import ScrollToTop from "./Modules/Home/scroll";

import MilkProduct from "./Modules/Products/Biscuit/MilkBiscuit";
import GlucoseProduct from "./Modules/Products/Biscuit/GlucoseBiscuit";
import NiceProduct from "./Modules/Products/Biscuit/NiceBiscuit";
import MarieProduct from "./Modules/Products/Biscuit/MarieDay";
import DigestiveProduct from "./Modules/Products/Biscuit/Digestive";

import ChocolateRectangleProduct from "./Modules/Products/Rectagle/Chocolate-Rectangle";
import OrangeRectangleProduct from "./Modules/Products/Rectagle/Orange-Rectangle";
import StrawberryRectangleProduct from "./Modules/Products/Rectagle/Strawberry-Rectangle";
import MangoRectangleProduct from "./Modules/Products/Rectagle/Mango-Rectangle";
import PineappleRectangleProduct from "./Modules/Products/Rectagle/Pineapple-Rectangle";

import ChocolateRoundProduct from "./Modules/Products/Round/Chocolate-Round";
import OrangeRoundProduct from "./Modules/Products/Round/Orange-Round";
import StrawberryRoundProduct from "./Modules/Products/Round/Strawberry-Round";
import MangoRoundProduct from "./Modules/Products/Round/Mango-Round";
import PineappleRoundProduct from "./Modules/Products/Round/Pineapple-Round";
import LoreoRoundProduct from "./Modules/Products/Round/Lorio-Round";

import VanillaATCProduct from "./Modules/Products/ATC/Vanilla-ATC";
import MilkATCProduct from "./Modules/Products/ATC/Milk-ATC";
import PineappleATCProduct from "./Modules/Products/ATC/Pineapple-ATC";
import MangoATCProduct from "./Modules/Products/ATC/Mango-ATC";
import StrawberryATCProduct from "./Modules/Products/ATC/Strawberry-ATC";
import OrangeATCProduct from "./Modules/Products/ATC/Orange-ATC";
import ChcolateATCProduct from "./Modules/Products/ATC/Chocolate-ATC";

import ChocolateProduct from "./Modules/Products/Crispy/Chocolate";
import ShortcakeProduct from "./Modules/Products/Crispy/ShortCake";
import ShortbreadProduct from "./Modules/Products/Crispy/Shortbread";
import ButterProduct from "./Modules/Products/Crispy/Butter";
import SodaProduct from "./Modules/Products/Crispy/Soda";
import SaltProduct from "./Modules/Products/Crispy/Salt";
import MiniProduct from "./Modules/Products/Crispy/Mini";
import ChocoChipProduct from "./Modules/Products/Crispy/Chocochipcookies";

import ChocolateWafferProduct from "./Modules/Products/Waffer/Chocolate-Waffer";
import OrangeWafferProduct from "./Modules/Products/Waffer/Orange-Waffer";
import StrawberryWafferProduct from "./Modules/Products/Waffer/Strawberry-Waffer";
import VannilaWafferProduct from "./Modules/Products/Waffer/Vanilla-Waffer";

import ChocolateRollProduct from "./Modules/Products/Roll/Chocolate-Roll";
import OrangeRollProduct from "./Modules/Products/Roll/Orange-Roll";
import StrawberryRollProduct from "./Modules/Products/Roll/Strawberry-Roll";
import VannilaRollProduct from "./Modules/Products/Roll/Vanilla-Roll";

import OrangeConeProduct from "./Modules/Products/Cone/Orange-Cone";
import StrawberryConeProduct from "./Modules/Products/Cone/Strawberry-Cone";
import ChocolateConeProduct from "./Modules/Products/Cone/Chocolate-Cone";
import PrivacyPolicy from "./Modules/PrivacyPolicy/Privacy";

export default function AppRouter() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />

        {/* BISCUITS */}
        <Route path="/biscuits/milk" element={<MilkProduct />} />
        <Route path="/biscuits/glucose" element={<GlucoseProduct />} />
        <Route path="/biscuits/nice" element={<NiceProduct />} />
        <Route path="/biscuits/marie" element={<MarieProduct />} />
        <Route path="/biscuits/digestive" element={<DigestiveProduct />} />

        {/* RECTANGLE CREAM */}
        <Route
          path="/rectangle-cream-biscuit/rectangle-chocolate"
          element={<ChocolateRectangleProduct />}
        />
        <Route
          path="/rectangle-cream-biscuit/rectangle-orange"
          element={<OrangeRectangleProduct />}
        />
        <Route
          path="/rectangle-cream-biscuit/rectangle-strawberry"
          element={<StrawberryRectangleProduct />}
        />
        <Route
          path="/rectangle-cream-biscuit/rectangle-mango"
          element={<MangoRectangleProduct />}
        />
        <Route
          path="/rectangle-cream-biscuit/rectangle-pineapple"
          element={<PineappleRectangleProduct />}
        />

        {/* ROUND CREAM */}
        <Route
          path="/round-cream-biscuit/round-chocolate"
          element={<ChocolateRoundProduct />}
        />
        <Route
          path="/round-cream-biscuit/round-orange"
          element={<OrangeRoundProduct />}
        />
        <Route
          path="/round-cream-biscuit/round-strawberry"
          element={<StrawberryRoundProduct />}
        />
        <Route
          path="/round-cream-biscuit/round-mango"
          element={<MangoRoundProduct />}
        />
        <Route
          path="/round-cream-biscuit/round-pineapple"
          element={<PineappleRoundProduct />}
        />
        <Route
          path="/round-cream-biscuit/round-loreo"
          element={<LoreoRoundProduct />}
        />

        {/* ATC CREAM */}
        <Route path="/atc/chocolate" element={<ChcolateATCProduct />} />
        <Route path="/atc/orange" element={<OrangeATCProduct />} />
        <Route path="/atc/strawberry" element={<StrawberryATCProduct />} />
        <Route path="/atc/mango" element={<MangoATCProduct />} />
        <Route path="/atc/pineapple" element={<PineappleATCProduct />} />
        <Route path="/atc/vanilla" element={<VanillaATCProduct />} />
        <Route path="/atc/milk" element={<MilkATCProduct />} />

        {/* CRISPY BITES */}
        <Route
          path="/crispy-biscuit/chocolate"
          element={<ChocolateProduct />}
        />
        <Route
          path="/crispy-biscuit/shortcake"
          element={<ShortcakeProduct />}
        />
        <Route
          path="/crispy-biscuit/shortbread"
          element={<ShortbreadProduct />}
        />
        <Route
          path="/crispy-biscuit/butter-cookies"
          element={<ButterProduct />}
        />
        <Route path="/crispy-biscuit/soda-crackers" element={<SodaProduct />} />
        <Route path="/crispy-biscuit/salt-biscuits" element={<SaltProduct />} />
        <Route path="/crispy-biscuit/mini-crackers" element={<MiniProduct />} />
        <Route
          path="/crispy-biscuit/choco-chip-cookies"
          element={<ChocoChipProduct />}
        />

        {/* WAFFERS (spelling kept to match your folder names) */}
        <Route
          path="/waffers/chocolate-waffer"
          element={<ChocolateWafferProduct />}
        />
        <Route
          path="/waffers/orange-waffer"
          element={<OrangeWafferProduct />}
        />
        <Route
          path="/waffers/strawberry-waffer"
          element={<StrawberryWafferProduct />}
        />
        <Route
          path="/waffers/vannila-waffer"
          element={<VannilaWafferProduct />}
        />

        {/* ROLLS */}
        <Route
          path="/rolls/chocolate-roll"
          element={<ChocolateRollProduct />}
        />
        <Route path="/rolls/orange-roll" element={<OrangeRollProduct />} />
        <Route
          path="/rolls/strawberry-roll"
          element={<StrawberryRollProduct />}
        />
        <Route path="/rolls/vannila-roll" element={<VannilaRollProduct />} />

        {/* CONE */}
        <Route path="/cone/chocolate-cone" element={<ChocolateConeProduct />} />
        <Route path="/cone/orange-cone" element={<OrangeConeProduct />} />
        <Route
          path="/cone/strawberry-cone"
          element={<StrawberryConeProduct />}
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<h1>Page Not Found</h1>} />
      </Routes>
    </>
  );
}
